import React, { useContext, useEffect } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import {
  Content,
  CardLatestDeliveries,
  ContainerDescription,
  ContentAvatar,
  DataUser,
  IconContainer,
  IconContainerAction,
  IconFA5,
  IconFE,
  StatusDelivery,
  TextDeliveries,
  TitleDataUser,
  TitleDelivery,
} from "./styles";
import { Header, Button, Container, CardDrivers } from "../../../components";
import { themes } from "../../../design/colors";
import Profile from "../Clients";
import RegisterDriverContext from "../../../context/registerDriver";
import CardRoutes from "../../../components/CardRoutes";

function DriversAdmin() {
  const navigation = useNavigation();
  const { drivers } = useContext(RegisterDriverContext);

  function handleAddDriver() {
    navigation.navigate("AddDriverAdmin", { edit: false });
  }

  function handleEditDriver(id: number) {
    navigation.navigate("AddDriverAdmin", { edit: true, id });
  }

  return (
    <Container>
      <Header name="Bruno Morais" />
      <Content>
        <TextDeliveries>Motoristas cadastrados</TextDeliveries>
        <Button title="Adicionar novo motorista" icon="plus" onPress={handleAddDriver} />
        {drivers.map((item: any, index: number) => (
          <CardDrivers
            key={index}
            first={index === 0 && true}
            title={item.name}
            status={item.active === 1 ? 'Ativo' : 'Inativo'}
            onPress={() => handleEditDriver(item.id)}
          /> 
        ))}
      </Content>
    </Container>
  );
}

export default DriversAdmin;
